const initialState = {
  userInfo: false,
  showMenu: true,
  forgotEmail: false,
};

export default function User(state = initialState, action) {
  switch (action.type) {
    case "USER/SETUSERINFO":
      return {
        ...state,
        userInfo: action.userInfo,
      };
    case "USER/SHOWMENU":
      return {
        ...state,
        showMenu: action.showMenu,
      };
    case "USER/SETFORGOTEMAIL":
      return {
        ...state,
        forgotEmail: action.forgotEmail,
      };
    default:
      return state;
  }
}
